<template>
  <div class="page-stack">
    <section class="surface-card filter-card">
      <div class="filter-main">
        <el-input
          v-model.trim="filters.keyword"
          clearable
          prefix-icon="el-icon-search"
          placeholder="消息/业务/Attempt/Ref/Batch ID、接收人手机号或用户 ID"
          @keyup.enter.native="search"
          @clear="search"
        />
        <el-select v-model="filters.status" clearable placeholder="全部状态" @change="search">
          <el-option label="等待回调" value="sending" />
          <el-option label="已接通" value="connected" />
          <el-option label="未接通" value="not_connected" />
          <el-option label="已取消" value="cancelled" />
          <el-option label="失败" value="failed" />
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      </div>
      <div class="filter-note"><i class="el-icon-lock"></i> 手机号支持完整号码、国家码数字及以 0 开头的本地号码</div>
    </section>

    <section class="surface-card">
      <div class="section-head">
        <div>
          <p class="eyebrow">MESSAGE LEDGER</p>
          <h3>发送记录</h3>
        </div>
        <span class="record-count">共 {{ total }} 条</span>
      </div>

      <el-table v-loading="loading" :data="items" class="clean-table" empty-text="暂无匹配记录">
        <el-table-column label="消息 / 业务" min-width="220">
          <template slot-scope="{ row }">
            <button class="text-link mono strong" @click="openDetail(row.messageId)">{{ row.messageId }}</button>
            <small class="table-subline">{{ row.bizId }}</small>
          </template>
        </el-table-column>
        <el-table-column label="场景" min-width="190">
          <template slot-scope="{ row }">
            <span class="scene-name">{{ row.scene }}</span>
            <small class="table-subline">{{ row.sourceSystem }} · {{ row.actualChannel }}</small>
          </template>
        </el-table-column>
        <el-table-column label="接收人" min-width="150">
          <template slot-scope="{ row }">{{ row.receiverPhone || row.receiverMasked }}</template>
        </el-table-column>
        <el-table-column label="发送内容" min-width="260" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.renderedContent || '历史记录未留存正文' }}</template>
        </el-table-column>
        <el-table-column label="短信通道" min-width="150">
          <template slot-scope="{ row }">{{ row.smsChannel || '—' }}</template>
        </el-table-column>
        <el-table-column label="Sender ID" min-width="130">
          <template slot-scope="{ row }">{{ row.senderId || '—' }}</template>
        </el-table-column>
        <el-table-column label="状态" width="130">
          <template slot-scope="{ row }"><status-tag :status="row.status" /></template>
        </el-table-column>
        <el-table-column label="候选" width="90" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.fallbackCandidate" class="candidate-dot" title="已生成降级候选"></span>
            <span v-else class="muted-text">—</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" min-width="180">
          <template slot-scope="{ row }">{{ formatDate(row.createdAt) }}</template>
        </el-table-column>
        <el-table-column width="80" align="right">
          <template slot-scope="{ row }">
            <el-button type="text" @click="openDetail(row.messageId)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-row">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page.sync="page"
          :page-size="size"
          :total="total"
          @current-change="load"
        />
      </div>
    </section>
  </div>
</template>

<script>
import { getMessages } from '../api/admin'
import StatusTag from '../components/StatusTag.vue'

export default {
  name: 'MessageListView',
  components: { StatusTag },
  data () {
    return {
      loading: false,
      items: [],
      total: 0,
      page: 1,
      size: 20,
      filters: {
        keyword: '',
        status: ''
      }
    }
  },
  created () {
    this.load()
  },
  methods: {
    async load () {
      this.loading = true
      try {
        const result = await getMessages({
          page: this.page,
          size: this.size,
          keyword: this.filters.keyword || undefined,
          status: this.filters.status || undefined
        })
        this.items = result.items
        this.total = result.total
      } catch (error) {
        this.$message.error('发送记录加载失败')
      } finally {
        this.loading = false
      }
    },
    search () {
      this.page = 1
      this.load()
    },
    openDetail (messageId) {
      this.$router.push(`/messages/${messageId}`)
    },
    formatDate (value) {
      return value ? value.replace('T', ' ') : '—'
    }
  }
}
</script>
